// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/** Ripples */\n/** Elements */\n/* Palette generated by Material Palette - materialpalette.com/blue/amber */\n/** Ripples */\n/** Elements */\ntable[data-v-bc53260c] {\n  table-layout: fixed;\n  width: auto !important;\n}\n.narrow_col[data-v-bc53260c] {\n  text-align: center !important;\n  padding-left: 0;\n  padding-right: 0;\n  word-break: break-all;\n}\n.narrow_col .v-icon[data-v-bc53260c] {\n  width: 40px;\n}", ""]);
// Exports
module.exports = exports;
